@if (es.errors.length > 0) {
  <div class="error-display">
    <button (click)="es.controlForm?.activateControl(es.controlError.formName)" aria-label="{{es.controlError.text}}"
            class="error"
            mat-flat-button>
      <mat-error>
        {{ es.controlError.text }}
        <mat-icon matSuffix>launch</mat-icon>
      </mat-error>
    </button>
    <div>
      <button (click)="es.activatePrevControl()" [disabled]="es.controlIdx===0"
              mat-icon-button>
        <mat-icon>navigate_before</mat-icon>
      </button>
      <mat-error>{{ es.controlIdx + 1 }} / {{ es.errors.length }}</mat-error>
      <button (click)="es.activateNextControl()"
              [disabled]="es.controlIdx >= es.errors.length-1"
              mat-icon-button>
        <mat-icon>navigate_next</mat-icon>
      </button>
    </div>
  </div>
}
<button (click)="close()" class="close" mat-icon-button>
  <mat-icon>close</mat-icon>
</button>
@if (es.info.length > 0) {
  <div class="error-display">
    @for (info of es.info; track $index) {
      <app-literal [class]="info.class" [value]="info.label" i18n-value innerWidth="4" outerWidth="4"></app-literal>
    }
  </div>
}
